module.exports = __webpack_public_path__ + "static/screen-3-7e05c916aaa4908b9cbb5ae76190653d.png";